import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-hero-tvc',
  templateUrl: './hero-tvc.component.html',
  styleUrls: ['./hero-tvc.component.scss']
})
export class HeroTvcComponent implements OnInit 
{
  public showCTA: boolean;
  public isTabletOrSmallerDevice: boolean;

  private router: Router;
  private clientService: ClientService;

  constructor
  (
    @Inject(DOCUMENT) private document: Document,
    router: Router, 
    clientService: ClientService,
  ) 
  { 
    this.router = router, 
    this.clientService = clientService 
  }

  public ngOnInit(): void 
  {
    this.isTabletOrSmallerDevice = this.clientService.checkForTabletView();
    setTimeout( () => this.showCTA = true , 1000);
    this.animateHeader();
  }

  public startVideo(): void
  {
    const videoTag: any = document.getElementById('my_video_1');
    videoTag.play();
  }

  public animateHeader(): void
  {
    gsap.registerPlugin(SplitText);
    gsap.registerEffect({
      name: "pulse",
      effect: (targets, config) => {
        tl = gsap.timeline({repeat: 3, repeatDelay: 0.3 });
        tl.to(targets, { scale: 1.2, duration: 0.3, ease: "back.in(4)" })
          .to(targets, { scale: 1, duration: 0.3, ease: "back.out(4)" });
        return tl
      },
      defaults: {duration: 0.5},
      extendTimeline: true
    });
    
    if(this.isTabletOrSmallerDevice)
    {
      var tl = gsap.timeline({repeat: -1, repeatDelay: 1.5});
    }
    else
    {
      var tl = gsap.timeline({repeat: -1, repeatDelay: 0.85});
    }

    var mySplitChar = new SplitText("#splitit", {type:"chars"})
    var chars = mySplitChar.chars;
    
    gsap.set("#splitit", {transformOrigin:"center center"});
    
    tl.call(this.startVideo, null , null )
    tl.add("start");
    
    tl.fromTo(chars, {y: 1000, rotate: 10, opacity:0},
      { duration: 1, 
        stagger: 0.1,
        y: 0,
        rotate: 0,   
        opacity:1,  
        ease: "power4.inOut",
        }, this.isTabletOrSmallerDevice ? "+=0" : "+=3.5")
      .from(".lodpakke", {
        duration: 0.8, 
        y:1000, 
        x:-2500,
        scale: 2, 
        rotationX: 40,
        rotationY: 180,
        rotationZ: 90,
        skewX: "10deg",  
        ease: "expo.out"}, "-=0.8")
      .from(".cta", {autoAlpha:0}, "-=0.3")
      .to(chars, {autoAlpha:0, y:-1000}, "+=1.5")
      .to(".lodpakke", {
        duration: 0.9, 
        y: 1400, 
        x:1800, 
        rotationX: 40,
        skewX: "30deg",
        ease: "back.in(1)"}, "-=1.3")
      .fromTo(".txt2", {y: 2000, rotate: 30}, 
        {
          y: 0, 
          rotate: 0,
          duration: 1, 
          ease: "power4.inOut",}, "-=1.2")
      .from(".txt3", {autoAlpha:0, ease: "expo.inOut"}, ">")
      .to(".txt2", {autoAlpha:0, y:-1000, duration:0.7,  ease: "power4.inOut"}, "+=1.5")
      .to(".txt3", {autoAlpha:0, ease: "expo.inOut"}, "<")
      .from(".txt4", {autoAlpha:0, ease: "expo.inOut" }, "-=0.5")
      .from(".txt5", {autoAlpha:0, ease: "expo.inOut"}, "-=0.3")
      .from(".lodpakke2", {
        duration: 0.8, 
        y:1000, 
        x:1000,
        scale: 2, 
        rotation: "1.25rad", 
        skewX: "10deg", 
        ease: "power.inOut"}, "-=0.7"); 
  }

  public play(): boolean
  {
    return true;
  }

  public redirectToShop(): void
  {
    this.router.navigateByUrl('/lodder-til-salg/lodpakker');
  }
}
